module.exports = __webpack_public_path__ + "static/media/26UNRWA24.827b791c.jpg";